import { Form } from '@mairistem/composants';
import { Icon, Panel } from '@mairistem/finances-utils';
import React from 'react';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const InventaireComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group className="panelRow">
          <Form.Input
            name="actif"
            key="actif"
            value={data?.actif ?? ''}
            title={data?.actif ?? ''}
            label="Identifiant d'actif"
            width={8}
            onChange={handleChange}
            data-testid="identifiantActif"
          />
          <Form.Input
            name="bien"
            key="bien"
            label="Fiche de bien"
            width={6}
            data-testid="ficheBien"
            readOnly
          />
          <Form.Input
            control={Icon}
            name="magic"
            size="large"
            circular
            width={2}
            className="panelButton"
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default InventaireComponent;
